import React, { Fragment, useEffect, useState, useCallback, useMemo } from "react";
import {
  Button,
  Card,
  CardBody,
  Badge,
  Input,
  Label,
} from "reactstrap";
import moment from "moment";
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import DropDownActions from "../../common/DropDownActions";
import ViewProcessLeaves from "./ViewProcessLeaves";
import api from "../../../apis/api";
import Notifications from "../../../components/common/Notifications";
import {
  PopUp,
  PopUpSuccess,
} from "../../../components/adminSettings/index";
import "../../../style/Myappliedleavelist.css";
import { MdCancel } from "react-icons/md";

const loginUser = JSON.parse(localStorage.getItem("user"));
const MyAppliedLeavesList = React.memo(
  ({
    empTask = [],
    handledelAppliedLeaves,
    handlerecholidayCalendarArray,
    handleleavestatus,
    handleSelectedTask,
    handleDelTask,
  }) => {
    const history = useHistory();
    const [filterStatus, setFilterStatus] = useState("All");
    const [filteredList, setFilteredList] = useState([]);
    const [isListView, setIsListView] = useState(true);
    const [isDetailView, setIsDetailView] = useState(false);

    const [leaverequestDetails, setLeaverequestDetails] = useState([]);
    const [myleavedetailedlist, setmyleavelist] = useState([]);
    const [myappliedleavelist, setmyappliedleavelist] = useState([]);
    const [holidayCalendarArray, setholidayCalendarArray] = useState([]);
    const [dateArray, setDateArray] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [error, setError] = useState(null);
    const [isopenpopup, setisopenpopup] = useState(false);
    const [isopenpopupSuccess, setisopenpopupSuccess] = useState(false);
    const [curDelId, setcurDelId] = useState(0);
    const [selectedLeaveType, setSelectedLeaveType] = useState("All");
const currentYear = new Date().getFullYear();
const [selectedYear, setSelectedYear] = useState(currentYear);
const yearOptions = [];
for (let y = currentYear; y >= currentYear - 5; y--) {
  yearOptions.push(y);
}
const leaveColorMap = {
  "General Leave(GL)": "#fff8c5",
  "Privilege Leave(PL)": "#e1efff",
  "Loss Of Pay(LOP)": "#e3ffe9",
  "Special Medical Leave(SML)": "#f2e7ff",
};
const leaveOrder = [
  "General Leave(GL)",
  "Privilege Leave(PL)",
  "Special Medical Leave(SML)",
  "Loss Of Pay(LOP)",
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'white',
    color: 'black',
    borderColor: state.isFocused ? '#28a745' : '#28a745',
    width: '260px',
    fontWeight: '600',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'black',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#28a745' : state.isFocused ? '#28a745' : 'white',
    color: state.isSelected ? 'white' : 'black',
  }),
};

const yearCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'white',
    color: 'black',
    borderColor: state.isFocused ? '#28a745' : '#28a745',
    width: '120px',
    fontWeight: '600',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'black',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#28a745' : state.isFocused ? '#28a745' : 'white',
    color: state.isSelected ? 'white' : 'black',
  }),
};
const yearCustomStyles1 = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'transparent',
    border: '1.5px solid rgba(255,255,255,0.6)',
    boxShadow: 'none',
    minHeight: '38px',
    height: '38px',
    width: '110px',
    borderRadius: '6px',
    color: '#fff',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#fff',
    fontWeight: 600,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#fff',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#0f9d8a' : state.isFocused ? '#e6f7f4' : '#fff',
    color: state.isSelected ? '#fff' : '#000',
  }),
};

const leaveTypeOptions = useMemo(() => [
  { value: 'All', label: 'All Leave Types' },
  ...taskList.filter((l) => leaveColorMap[l.type]).map((l) => ({ value: l.type, label: l.type }))
], [taskList]);

const yearSelectOptions = useMemo(() => yearOptions.map(y => ({ value: y, label: y })), []);

    /* ---------------- FILTER ---------------- */
  useEffect(() => {
  let data = empTask;

  // Transaction status
  if (filterStatus !== "All") {
    data = data.filter((x) => x.leaveStatus === filterStatus);
  }

  // Leave type
  if (selectedLeaveType !== "All") {
    data = data.filter((x) => x.type === selectedLeaveType);
  }

  // Year filter (createdDate)
  if (selectedYear) {
    data = data.filter(
      (x) => moment(x.createdDate).year() === selectedYear
    );
  }

  setFilteredList(data);
}, [filterStatus, selectedLeaveType, selectedYear, empTask]);

useEffect(() => {
  let array2 = [];
  const fetchApi = async () => {
      await api
              .dbLeaveTypes()
              .GetLeaveTypesByEmpId(parseInt(loginUser.EmployeeId))
              .then((res) => array2.push(res.data));
            setTaskList(array2[0]);
  };
  fetchApi();
    }, [empTask]);
    /* ---------------- SUMMARY CARDS ---------------- */
    const getLeaveTotal = (type) =>
      empTask
        .filter((x) => x.type === type)
        .reduce((a, b) => a + (b.leaveBalance || 0), 0);

    /* ---------------- DELETE ---------------- */
    const handleDelAppliedleave = useCallback((id) => {
      setcurDelId(id);
      setisopenpopup(true);
    }, []);

    const hadleDelWithPopYes = () => {
      handledelAppliedLeaves(curDelId);
      setisopenpopup(false);
      setisopenpopupSuccess(true);
    };

    const hadleSuccessPop = () => {
      setisopenpopupSuccess(false);
      setError({ message: "Applied leave deleted successfully", status: 200 });
      setTimeout(() => window.location.reload(), 2000);
    };

    /* ---------------- VIEW DETAILS ---------------- */
    const getDates = (arrlist) => {
      const dates = [];
      arrlist.forEach((el) => {
        const start = new Date(el.fromDate);
        const end = new Date(el.toDate);
        const days = Math.floor((end - start) / 86400000);
        for (let i = 0; i <= days; i++) {
          dates.push(moment(start).add(i, "days").format("DD-MM-YYYY"));
        }
      });
      setDateArray(dates);
    };

    const handleDetails = async (leaveRequestId, employeeId) => {
      let arr = [],
        arr1 = [],
        arr2 = [],
        arr3 = [];

      await api
        .dbLeaveTypes()
        .GetLeaveRequestById(leaveRequestId)
        .then((res) => setLeaverequestDetails(res.data));

      await api
        .dbLeaveTypes()
        .GetLeaveTypesByEmpId(employeeId)
        .then((res) => arr.push(res.data));

      await api
        .dbLeaveTypes()
        .GetAppliedLeavesByRequestId(leaveRequestId)
        .then((res) => arr1.push(res.data));

      await api
        .dbLeaveTypes()
        .GetAppliedLeavesByEmpId(employeeId)
        .then((res) => arr2.push(res.data));

      await api
        .dbcalendar()
        .GetHolidayCalendarList()
        .then((res) => arr3.push(res.data));

      setmyleavelist(arr[0]);
      setmyappliedleavelist(arr1[0]);
      getDates(arr2[0]);
      setholidayCalendarArray(arr3[0]);
      setIsListView(false);
      setIsDetailView(true);
    };

    const toggleview = () => {
      setIsListView(true);
      setIsDetailView(false);
    };
const getDayType = (noOfDays) => {
  if (noOfDays === 1 || noOfDays > 1) return "Full Day";
  if (noOfDays === 0.5) return "Half Day";
  return "";
};

    return (
      <Fragment>
        <div className="container-fluid px-4">
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center p-3 text-white headtab" style={{ background: "#0f9d8a" }}>
          <h5 className="mb-0">My Applied Leaves</h5>
          <div className="d-flex align-items-center gap-4">
           
            <Button className="apply-btn" style={{ width: '120px', background: "#0f9d8a", border: "1.5px solid rgba(255,255,255,0.6)" }} onClick={() => history.push('/ApplyMyLeaves')}>
              Apply
            </Button>
          </div>
        </div>

        {/* SUMMARY CARDS */}
    <div className="row g-4 mt-4">
  {taskList
    .filter((leave) => leaveOrder.includes(leave.type))
    .sort(
      (a, b) =>
        leaveOrder.indexOf(a.type) - leaveOrder.indexOf(b.type)
    )
    .map((leave, index) => (
      <div className="col-md-3 mb-3" key={index}>
        <Card
          style={{
            background: leaveColorMap[leave.type] || "#f8f9fa",
            borderRadius: "10px",
          }}
        >
          <CardBody>
            <small className="text-muted">{leave.type}</small>

            <h2
              className="fw-bold mt-2"
              style={
                leave.type === "Loss Of Pay(LOP)"
                  ? { color: "rgb(42 100 55)" }
                  : leave.type === "Privilege Leave(PL)"
                  ? { color: "rgb(36 82 136)" }
                  : leave.type === "General Leave(GL)"
                  ? { color: "rgb(133 101 0)" }
                  : { color: "rgb(72 22 131)" }
              }
            >
              {Number(leave.leaveBalance || 0).toFixed(2)}
            </h2>
          </CardBody>
        </Card>
      </div>
    ))}
</div>




        {/* FILTER */}
        <div className="mt-4">

  <Label>Transaction Type</Label>

  <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">

    {/* LEFT – Transaction buttons */}
    <div className="d-flex gap-2 transaction-filter">
      {["All", "Approved", "Pending", "Rejected"].map((s) => {
        const isActive = filterStatus === s;

        const bg =
          s === "Approved"
            ? "#2ecc71"
            : s === "Pending"
            ? "#f1c40f"
            : s === "Rejected"
            ? "#e74c3c"
            : "#0f9d8a";

        return (
          <button
            key={s}
            className={`filter-btn ${isActive ? "active" : ""}`}
            style={{
              backgroundColor: isActive ? bg : "#fff",
              color: isActive ? "#fff" : "#333",
            }}
            onClick={() => setFilterStatus(s)}
          >
            {s}
          </button>
        );
      })}
    </div>

    {/* RIGHT – Leave Type + Year */}
    <div className="d-flex align-items-center gap-3">
      {/* Leave Type */}
      <Select
        options={leaveTypeOptions}
        value={leaveTypeOptions.find(
          (option) => option.value === selectedLeaveType
        )}
        onChange={(opt) => setSelectedLeaveType(opt.value)}
        styles={customStyles}
        placeholder="All Leave Types"
        isSearchable={false}
        menuPortalTarget={document.body}
        classNamePrefix="leave-select"
      />

      {/* Year */}
      <Select
        options={yearSelectOptions}
        value={yearSelectOptions.find(
          (option) => option.value === selectedYear
        )}
        onChange={(opt) => setSelectedYear(opt.value)}
        styles={yearCustomStyles}
        placeholder="Year"
        isSearchable={false}
        menuPortalTarget={document.body}
        classNamePrefix="leave-select"
      />
    </div>

  </div>
</div>



        {/* TABLE */}
        {isListView && (
          <div className="table-responsive mt-4">

            <table className="table align-middle">
               <thead className="table-light">
                <tr>
                  <th>Leave Type</th>
                  <th>Posted on</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Days</th>
                  <th>Reason</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody style={{fontSize:"13px"}}>
                {filteredList.map((el, i) => (
                  <tr key={i}>
                    <td>
                     {el.type} {" "}
                      <Badge
                        style={{
                          padding: "4px 10px",
                          borderRadius: "15px",
                          backgroundColor:
                            el.leaveStatus === "Approved"
                              ? "#e6f9f2" /* light green */
                              : el.leaveStatus === "Pending"
                              ? "#f9ebc3ff" /* light yellow */
                              : "#ffe6e6" /* light red */,
                          color:
                            el.leaveStatus === "Approved"
                              ? "#065F46" /* dark green text */
                              : el.leaveStatus === "Pending"
                              ? "#92400E" /* dark amber text */
                              : "#8b0b0b" /* dark red text */,
                          fontWeight: 600,
                        }}
                      >
                        {el.leaveStatus}
                      </Badge>
                    </td>
                    <td>{moment(el.createdDate).format("DD MMM YYYY")}</td>
                   <td>
  {moment(el.fromDate).format("DD MMM YYYY")}
  <div className="text-muted">{getDayType(el.noOfDays)}</div>
</td>

<td>
  {moment(el.toDate).format("DD MMM YYYY")}
  <div className="text-muted">{getDayType(el.noOfDays)}</div>
</td>
                    <td>{el.noOfDays}</td>
                    <td>{el.reason}</td>
                  
                    <td>
                   {el.leaveStatus === "Pending" && (
  <MdCancel
    size={22}
    title="Cancel Leave"
    style={{
      cursor: "pointer",
      color: "#e74c3c",
    }}
    onClick={() => handleDelAppliedleave(el.leaveRequestId)}
  />
)}


                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
</div>
        {/* DETAILS VIEW */}
        {isDetailView && (
          <ViewProcessLeaves
            leaverequestDetails={leaverequestDetails}
            myleavedetailedlist={myleavedetailedlist}
            myappliedleavelist={myappliedleavelist}
            holidayCalendarArray={holidayCalendarArray}
            handlerecholidayCalendarArray={handlerecholidayCalendarArray}
            handleleavestatus={handleleavestatus}
            empTask={empTask}
            handleSelectedTask={handleSelectedTask}
            handleDelTask={handleDelTask}
            dateArray={dateArray}
            toggleview={toggleview}
          />
        )}

        <Notifications notifications={error} />

        {isopenpopup && (
          <PopUp
            hadleDelWithPopYes={hadleDelWithPopYes}
            hadleDelWithPopNo={() => setisopenpopup(false)}
          />
        )}

        {isopenpopupSuccess && (
          <PopUpSuccess hadleSuccessPop={hadleSuccessPop} />
        )}
      </Fragment>
    );
  }
);

export default MyAppliedLeavesList;
